import { useEffect } from "react";

const SpaceRedirect = () => {
  useEffect(() => {
    window.location.replace("/space.html");
  }, []);
  return (
    <div data-testid="space-redirect" style={{ minHeight: "100vh", background: "#04060F" }} />
  );
};

export default SpaceRedirect;
